import React from "react"
import styled from "styled-components"
import { colors } from "../../../common/colors/app_colors"

const { black } = colors

export const ZoomSubtext = ({
    link,
    arrowDirection,
    clickFunction,
    teamName,
}) => {
    const arrowClass = `chevron fa fa-chevron-${arrowDirection} select-box-chev`
    return (
        <Subtext onClick={clickFunction}>
            {teamName && <p className="subtext vertical-align">{teamName}</p>}
            <p className="link">{link}</p>
            {arrowDirection && (
                <i className={arrowClass} aria-hidden="true"></i>
            )}
        </Subtext>
    )
}

const Subtext = styled.div`
    margin-left: auto;
    margin-top: auto;
    margin-bottom: auto;
    display: flex;
    cursor: pointer;
    p {
        display: inline-block;
        margin: 0px;
    }
    .subtext {
        margin-left: auto;
        padding-right: 20px;
        color: ${black};
        font-weight: bolder;
        max-width: 400px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .link {
        min-width: 26px;
        text-align: right !important;
    }
    .vertical-align {
        margin-top: auto;
        margin-bottom: auto;
    }
    .chevron {
        padding-left: 20px;
    }
    @media (max-width: 900px) {
        .subtext {
            max-width: 300px;
        }
    }
    @media (max-width: 425px) {
        .subtext {
            max-width: 125px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/zoom/zoom_subtext.jsx